import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";
const AuthService = {}

AuthService.login = function (data) {
	return fetch({
		url: '/auth/login',
		method: 'post',
		data: data,
		headers:{
			"x-api-key":X_API_KEY
		}
	})
}

AuthService.register = function (data) {
	return fetch({
		url: '/auth/register',
		method: 'post',
		data: data,
		headers:{
			"x-api-key":X_API_KEY
		}
	})
}

AuthService.logout = function () {
	return fetch({
		url: '/auth/logout',
		method: 'post',
		headers:{
			"x-api-key":X_API_KEY
		}
	})
}

AuthService.loginInOAuth = function () {
	return fetch({
		url: '/auth/loginInOAuth',
		method: 'post'
	})
}

AuthService.aktivasi = function (data) {
	return fetch({
		url: '/auth/aktivasi',
		method: 'post',
		data: data,
		headers:{
			"x-api-key":X_API_KEY
		}
	})
}

export default AuthService;
